import * as React from "react";

const Check: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                d="M3.61 2.89l-.72.72L7.28 8 2.89 12.39l.72.72L8 8.719l4.39 4.39.72-.719L8.717 8l4.391-4.39-.72-.72L8 7.282 3.61 2.89z"
                fill="#000"
            />
        </svg>
    );
};

export default React.memo(Check);
